// Shared score → colour mapping (Tailwind class or hex) so cards, orbs and maps agree.
const TONES = [
  { min: 90, cls: "text-[#C8A96E]", hex: "#C8A96E", hint: "A rare resonance. Pack your bags." },
  { min: 75, cls: "text-[#9CBF8E]", hex: "#9CBF8E", hint: "Strong alignment. This city echoes your chart." },
  { min: 55, cls: "text-white", hex: "#ffffff", hint: "Neutral currents. Worth a visit, not a move." },
  { min: -Infinity, cls: "text-[#A89C98]", hex: "#A89C98", hint: "Dissonance detected. Better cities await." },
];

export const scoreTone = (score) => TONES.find((t) => score >= t.min);
export const scoreClass = (score) => scoreTone(score).cls;
export const scoreHex = (score) => scoreTone(score).hex;
export const scoreHint = (score) => scoreTone(score).hint;

export function recentScanClass(scan) {
  if (scan.easter_egg) return "text-[#C8A96E]";
  if (scan.score >= 80) return "text-[#9CBF8E]";
  return "text-white";
}
